import React from "react";
import axios from "axios";
import { useState } from "react";

const Modal = ({ props, onClose, updateDescriptionState }) => {
  const [newDesc, setNewDesc] = useState(props.description);
  const [password, setPassword] = useState("");
  const [editingAllowed, setEditingAllowed] = useState(false);
  console.log(props._id);

  //update recipe
  const UpdateDescription = () => {
    if (editingAllowed) {
      axios
        .put(`https://the-menu-server-a0c079ab1940.herokuapp.com/api/recipes/${props._id}`, {
          description: newDesc,
        })
        .then((response) => {
          console.log("Description updated successfully", response.data);
          onClose(); // Close the modal after successful update
          updateDescriptionState(newDesc);
        })
        .catch((error) => {
          console.log("Error updating description:", error);
        });
    }
  };
  const checkPassword = () => {
    const expectedPassword = "gina"; // Replace with actual password
    if (password === expectedPassword) {
      setEditingAllowed(true);
    } else {
      alert("Incorrect password");
    }
  };

  return (
    <>
      {editingAllowed ? (
        <div className="edit">
          <label htmlFor="description">Edit Cooking Directions:</label>
          <textarea
            cols="100"
            rows="20"
            style={{ width: "100%" }}
            onChange={(e) => setNewDesc(e.target.value)}
            value={newDesc}
          />
          <button style={{ marginRight: "30px" }} onClick={UpdateDescription}>
            save
          </button>
          <button onClick={onClose}> close</button>
        </div>
      ) : (
        <div className="password">
          <label>Admin Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button onClick={checkPassword}>Submit</button>
        </div>
      )}
    </>
  );
};

export default Modal;
